module.exports = __webpack_public_path__ + "media/images/c_key-8cc4603fa1c5704af7d2faba26ff351d.jpeg";